import React, { useRef } from 'react'
import { TextField } from '@material-ui/core'
import moment from 'moment'

// Month pickers need a click on the calendar icon to open the picker which is not intuitive for most of users
// This components open the picker on Focus.
//
// Months are stored as full dates in the database. We have to handle this by parsing / formatting date
export const MonthPicker = (props) => {
  const ref = useRef()

  const value = props.value ? moment(props.value).format('YYYY-MM') : null

  const onChange = (event) => {
    props.onChange({ ...event, target: { ...event.target, value: moment(event.target.value, 'YYYY-MM-01').format('YYYY-MM-01') } })
  }

  return (
    <TextField
      type="month"
      variant="filled"
      name={props.id}
      required
      fullWidth
      inputProps={{ ref, onFocus: () => ref.current.showPicker() }}
      InputLabelProps={{ shrink: true }}
      {...props}
      value={value}
      onChange={onChange}
    />
  )
}
